import { render, staticRenderFns } from "./Image-Modal.vue?vue&type=template&id=552f0028&scoped=true&"
import script from "./Image-Modal.vue?vue&type=script&lang=ts&"
export * from "./Image-Modal.vue?vue&type=script&lang=ts&"
import style0 from "./Image-Modal.vue?vue&type=style&index=0&id=552f0028&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f0028",
  null
  
)

export default component.exports